export const sales = {
  title: 'Ventas',
  currency: {
    code: 'MAD',
    symbol: 'DH',
    position: 'after',
    decimalSeparator: ',',
    thousandSeparator: ' '
  },
  columns: {
    num: 'N° Venta',
    date: 'Fecha',
    customer: 'Cliente',
    total: 'Total',
    status: 'Estado',
    paymentMethod: 'Pago',
    paymentStatus: 'Estado del pago',
    items: 'Artículos',
    basicInfo: 'Información básica',
    financialInfo: 'Detalles financieros',
    systemInfo: 'Información del sistema',
    createdAt: 'Fecha de creación',
    updatedAt: 'Última modificación'
  },
  filters: {
    search: {
      label: 'Buscar',
      placeholder: 'Buscar una venta...'
    },
    sort: {
      label: 'Ordenar por',
      directions: {
        asc: 'Ascendente',
        desc: 'Descendente'
      }
    },
    status: {
      label: 'Estado',
      placeholder: 'Todos los estados',
      options: {
        completed: 'Completada',
        pending: 'Pendiente',
        cancelled: 'Cancelada'
      }
    },
    paymentMethod: {
      label: 'Método de pago',
      placeholder: 'Todos los métodos',
      options: {
        cash: 'Efectivo',
        card: 'Tarjeta',
        transfer: 'Transferencia',
        check: 'Cheque'
      }
    },
    paymentStatus: {
      label: 'Estado del pago',
      placeholder: 'Todos los estados',
      options: {
        paid: 'Pagado',
        partial: 'Parcial',
        unpaid: 'No pagado'
      }
    }
  },
  actions: {
    newSale: 'Nueva venta',
    view: 'Ver',
    edit: 'Editar',
    delete: 'Eliminar',
    print: 'Imprimir'
  },
  form: {
    title: {
      create: 'Nueva venta',
      edit: 'Editar venta'
    },
    customer: {
      label: 'Cliente',
      placeholder: 'Seleccionar cliente'
    },
    status: {
      label: 'Estado',
      placeholder: 'Seleccionar estado'
    },
    paymentMethod: {
      label: 'Método de pago',
      placeholder: 'Seleccionar método'
    },
    paymentStatus: {
      label: 'Estado del pago',
      placeholder: 'Seleccionar estado'
    },
    items: {
      label: 'Artículos',
      add: 'Añadir artículo',
      remove: 'Eliminar',
      product: 'Producto',
      quantity: 'Cantidad',
      unitPrice: 'Precio unitario',
      total: 'Total'
    },
    notes: {
      label: 'Notas',
      placeholder: 'Añadir notas...'
    },
    total: 'Total',
    save: 'Guardar',
    update: 'Actualizar',
    cancel: 'Cancelar',
    saving: 'Guardando...'
  },
  details: {
    title: 'Detalles de la venta',
    customerInfo: 'Información del cliente',
    saleInfo: 'Información de la venta',
    noCustomer: 'Cliente no especificado',
    createdAt: 'Creada el',
    updatedAt: 'Actualizada el',
    itemName: 'Artículo',
    unitPrice: 'Precio unitario',
    close: 'Cerrar'
  },
  confirmations: {
    delete: '¿Está seguro de que desea eliminar esta venta?'
  },
  errors: {
    insufficientStock: 'Stock insuficiente para uno o más artículos'
  },
  pagination: {
    totalItems: 'Total de ventas',
    itemsPerPage: 'Ventas por página',
    page: 'Página',
    of: 'de',
    next: 'Siguiente',
    previous: 'Anterior',
    showing: 'Mostrando',
    to: 'a',
    of: 'de',
    items: 'ventas'
  }
}; 